import { render, staticRenderFns } from "./offer-private.vue?vue&type=template&id=78006f15&scoped=true&"
var script = {}
import style0 from "./offer-private.vue?vue&type=style&index=0&id=78006f15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78006f15",
  null
  
)

export default component.exports